<template>
  <div class="views">
    <div v-if="data.length == 0" style="text-align: center;">
      NO REVIEW
    </div>
    <div v-else>
      <div class="review" v-for="(item, index) in data" :key="index">
        <div class="rating">
          <div class="rate-box">
            <img
              v-for="num in [1, 2, 3, 4, 5]"
              :src="num <= item.rating ? rateImg : unRateImg"
              :key="num"
            />
          </div>
          <span class="point">{{ item.rating || 0 }}</span>
        </div>
        <div class="i_d">{{ item.userName }} ON {{ item.createAt }}</div>
        <p class="description" v-text="item.comment"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getReview } from '../../api/review'

export default {
  name: 'views',
  data() {
    return {
      rateImg: require('../../assets/images/etc/rated@2x.png'),
      unRateImg: require('../../assets/images/etc/unrated-outline@2x.png'),
      data: ''
    }
  },
  created() {
    getReview(this.modalComponentPropData.serviceId).then(result => {
      this.data = result
      console.log('review result', result)
    })
  },
  computed: {
    ...mapGetters(['serviceDetail', 'modalComponentPropData'])
  }
}
</script>

<style lang="scss" scoped>
.views {
  width: 95%;
  .review {
    color: #000;
    margin: 0 0 32px 0;

    .rating {
      font-size: 25px;
      span {
        font-size: 20px;
        padding: 0 3px 0 0;
        /*vertical-align: bottom;*/
      }

      .point {
        font-family: Georgia;
        font-size: 24px;
        font-weight: bold;
        font-style: italic;
      }

      .rate-box {
        float: left;
        /*border: 1px solid green;*/
        position: relative;
        min-width: 110px;
        height: 27px;
        transition: all 0.3s;
        img {
          margin: 0 2px 2px 0;
          display: inline;
          width: 16px;
          height: 17px;
        }
      }
    }

    .i_d {
      font-family: Poppins;
      font-size: 15px;
      font-weight: 600;
      letter-spacing: 1px;
      margin: 15px 0 0;
    }

    .description {
      margin: 10px 0 0 0;
      overflow-y: hidden;
      width: 800px;
      max-height: 182px;
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 1px;
      text-align: left;
      color: #000000;
    }
  }
}
</style>
